const TERMLY_SCRIPT_ID = "termly-jssdk";
const TERMLY_SCRIPT_SRC = "https://app.termly.io/embed-policy.min.js";

/**
 * Injects or re-injects the Termly embed script so it scans the DOM for
 * [name="termly-embed"] divs and populates them. Call this when an embed
 * component mounts (e.g. when a dialog opens) so content appears after
 * close/reopen or when switching documents.
 */
export function loadTermlyScript(): void {
  if (typeof document === "undefined") return;
  const existing = document.getElementById(TERMLY_SCRIPT_ID);
  if (existing) {
    existing.remove();
  }
  const script = document.createElement("script");
  script.id = TERMLY_SCRIPT_ID;
  script.src = TERMLY_SCRIPT_SRC;
  script.async = true;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
}
